<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Informations</h4>
    <div class="card-body">
      <TextInputComponent
        value-key="name"
        label="Nom de l'événement"
        placeholder="Nom de l'événement"
        :required="true"
        class="mb-3"
      />

      <div class="row mb-3">
        <div class="col-12">
          <TextInputComponent
            value-key="slug"
            label="Slug de l'événement"
            placeholder="mon-evenement"
            sub-label="Identifiant utilisé dans le lien de l'événement."
            :required="false"
            class="mb-3"
          />
        </div>
        <div class="col-12 small">
          Lien public de l'événement: <a :href="eventUrl" target="_blank" rel="noopener noreferrer">{{ eventUrl }}</a>
          <br>
          Lien directe vers l'événement: <a :href="eventUrl" target="_blank" rel="noopener noreferrer">{{ eventUrl }}/inscription</a>
        </div>
      </div>

      <SelectInputComponent
        value-key="type"
        label="Type de l'événement"
        placeholder="Sélectionnez un type"
        :required="true"
        class="mb-3"
        :options="Object.values(TravelDbTypeEnum).map(type => ({ value: type, label: GetTravelTypeLabel(type) }))"
      />

      <div class="row mb-3">
        <div class="col-6">
        <DatePickerComponent
          value-key="startDate"
          :placeholder="'Date début'"
          :label="'Date début'"
          :required="true"
        />
        </div>
        <div class="col-6">
        <DatePickerComponent
          value-key="endDate"
          :min-date="travel.startDate"
          :placeholder="'Date fin'"
          :label="'Date fin'"
          :required="true"
        />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-6">
        <DatePickerComponent
          value-key="registrationStartDate"
          :placeholder="'Date de début des inscriptions'"
          :label="'Date de début des inscriptions'"
          :required="true"
        />
        </div>
        <div class="col-6">
        <DatePickerComponent
          value-key="registrationEndDate"
          :min-date="travel.registrationStartDate"
          :placeholder="'Date de fin des inscriptions'"
          :label="'Date de fin des inscriptions'"
          :required="true"
        />
        </div>
      </div>

      <NumberInputComponent
        value-key="nights"
        label="Nombre de nuits"
        placeholder="Nombre de nuits"
        :required="true"
        class="mb-3"
      />

      <div class="row">
        <div class="col-8">
          <TextInputComponent
            value-key="company"
            label="Nom de l'entreprise"
            placeholder="Nom de l'entreprise"
            :required="false"
            class="mb-3"
          />
        </div>
        <div class="col-4">
          <NumberInputComponent
            value-key="organisationMemberCount"
            label="Nombre d'organisateurs"
            placeholder="Nombre d'organisateurs"
            :required="true"
            class="mb-3"
          />
          </div>
      </div>
      <div class="row">
        <div class="col-12">
          <TextInputComponent
            value-key="emailContact"
            label="Email de contact"
            placeholder="Email de contact"
            :required="true"
            class="mb-3"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <CheckboxComponent
            value-key="birthDateRequired"
            label="Date de naissance demandée ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <CheckboxComponent
            value-key="passeportRequired"
            label="Passeport en cours de validité demandé ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12 ms-4" v-if="travel.passeportRequired">
          <CheckboxComponent
            value-key="passeportSixMonthsRequired"
            label="Passeport valide 6 mois après la date de retour ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <CheckboxComponent
            value-key="estaRequired"
            label="ESTA nécessaire ?"
            :required="true"
            class="mb-3"
          />
        </div>
         <div class="col-12">
          <CheckboxComponent
            value-key="userStatusRequired"
            label="Statut de l'utilisateur requis ? (Franchisé, collaborateur ect..)"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <MultiSelectComponent
              v-if="travel.userStatusRequired"
              value-key="usersStatusAvailable"
              label="Statuts disponibles pour les utilisateurs"
              :options="Object.values(UserStatusEnum)"
              :custom-label="(option) => GetUserStatusLabel(option as UserStatusEnum)"
              :required="false"
              :close-on-select="false"
              class="mb-3 mb-md-3"
            />
        </div>
        <div class="col-12 col-md-6">
          <CheckboxComponent
            value-key="invoiceEnabled"
            label="Page de facturation activée ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <CheckboxComponent
            value-key="companionsEnabled"
            label="Accompagnants autorisés ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <CheckboxComponent
            value-key="addressRequired"
            label="Adresse requise ?"
            :required="false"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <CheckboxComponent
            value-key="nationalityRequired"
            label="Nationalité requise lors de l'inscription ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <CheckboxComponent
            value-key="emergencyContactRequested"
            label="Contact d'urgence demandé ?"
            :required="true"
            class="mb-3"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <FlagPickerComponent
          value-key="isoCode"
          label="Drapeau associé à l'événement (optionnel)"
          :required="false"
          class="mb-3" />
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12">
            <AutocompleteComponent
              value-key="clientManagers"
              label="Liste des utilisateurs habilités à voir le Board Client de l'événement (en lecture uniquement)"
              placeholder="Entrez le nom d'un utilisateur"
              selectLabel="Selectionner"
              noElementFoundText="Aucun utilisateur trouvé"
              @search-change="searchclientManagersChange"
              :options="clientManagerssToAddList"
              :options-label-function="(obj) => `${obj.user.lastName?.toUpperCase()} ${obj.user.firstName}`"
              :required="false"
              :hide-selected="true"
              :allow-clear="true"
              :close-on-select="false"
              :clear-on-select="false"
              :multiple="true"
              class="mb-3"
            />
        </div>
      </div> -->

      <div class="row">
        <div class="d-flex justify-content-between"><h5>Templates d'Email Brevo</h5> <a href="https://app.brevo.com/templates/listing" target="_blank"><small><em><i class="fa-solid fa-arrow-up-right-from-square"></i> Brevo.com</em></small></a></div>
        <div class="col-12 col-md-6">
          <NumberInputComponent
            value-key="invitationTemplateId"
            label="Template email d'invitation"
            sub-label="Brevo #"
            placeholder="Entrez un template d'email"
            :required="true"
            type="number"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <NumberInputComponent
            value-key="confirmationTemplateId"
            label="Template email Confirmation Inscription"
            sub-label="Brevo #"
            placeholder="Entrez un template d'email"
            :required="true"
            type="number"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <NumberInputComponent
            value-key="optoutTemplateId"
            label="Template email Absents"
            sub-label="Brevo #"
            placeholder="Entrez un template d'email"
            :required="false"
            type="number"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <NumberInputComponent
            value-key="webInscriptionTemplateId"
            label="Template email Réception Fiche Inscription"
            sub-label="Brevo #"
            placeholder="Entrez un template d'email"
            :required="false"
            type="number"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-md-6">
          <NumberInputComponent
            value-key="reminderTemplateId"
            label="Template email Rappel 1"
            sub-label="Brevo #"
            placeholder="Entrez un template d'email"
            :required="false"
            type="number"
            class="mb-3"
          />
        </div>
      </div>
      <div class="row">
        <div class="d-flex justify-content-between"><h5>Templates de signature de document</h5> <a href="https://app.firma.dev/workspace/211eabc0-7a24-429b-931f-1609f4834d4e?tab=templates" target="_blank"><small><em><i class="fa-solid fa-arrow-up-right-from-square"></i> Firma.dev</em></small></a></div>
        <div class="col-12 col-md-6">
          <TextInputComponent
            value-key="firmaTemplateId"
            label="Template Firma (signature électronique)"
            sub-label="ID du modèle Firma (optionnel)"
            placeholder="Ex: tpl_xxxxxxxx"
            :required="false"
            class="mb-3"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-3" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Refus</h4>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <CheckboxComponent
            value-key="canRefuse"
            label="Les utilisateurs peuvent refuser leur participation à cet événement ?"
            :required="true"
            class="mb-3"
          />
        </div>
        <div class="col-12" v-if="travel.canRefuse">
          <CheckboxComponent
            value-key="needRefusalReason"
            label="Les utilisateurs doivent fournir une raison de refus ?"
            :required="true"
            class="mb-3"
          />
        </div>
      </div>
      <div class="row" v-if="travel.needRefusalReason">
        <div class="col-12">
          <TagInputComponent
            :value-key="`refusalReasons`"
            label="Raisons de refus"
            placeholder="Liste des raisons de refus possibles"
            :required="true"
            :tag-validator="tagValidator"
            duplicate-tag-text="Raison déjà existante"
            invalid-tag-text="Raison déjà existante"
            class="my-3 mt-md-0"
          />
        </div>
        <div class="col-12">
          <TagInputComponent
            :value-key="`refusalReasons2`"
            label="Vu avec (optionnel)"
            placeholder="Vu avec (optionnel)"
            :required="false"
            :tag-validator="tagValidator"
            duplicate-tag-text="Raison déjà existante"
            invalid-tag-text="Raison déjà existante"
            class="mt-3 mt-md-0"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Textes</h4>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <TextInputComponent
            value-key="refusalLabel"
            label="Texte du bouton de refus"
            sub-label="laisser vide pour utiliser la valeur par défaut 'Je ne participe pas au séjour'"
            placeholder="Texte du bouton de refus"
            :required="false"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <TextInputComponent
            value-key="refusalLongLabel"
            label="Texte de la page de refus"
            sub-label="laisser vide pour utiliser la valeur par défaut 'Vous avez décidé de passer votre tour pour le séjour'"
            placeholder="Texte de la page de refus"
            :required="false"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <TextInputComponent
            value-key="buttonPackageSelectionLabel"
            label="Texte du bouton de sélection du package"
            sub-label="laisser vide pour utiliser la valeur par défaut 'Je viens aux dates du Package'"
            placeholder="Texte du bouton de sélection du package"
            :required="false"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <TextInputComponent
            value-key="companionLabel"
            label="Comment nommer un accompagnant"
            sub-label="laisser vide pour utiliser la valeur par défaut 'Accompagnant'"
            placeholder="Comment nommer un accompagnant"
            :required="false"
            class="mb-3"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue';
import DatePickerComponent from '@/components/common/DatePickerComponent.vue';
import TextInputComponent from '@/components/common/TextInputComponent.vue';
import NumberInputComponent from '@/components/common/NumberInputComponent.vue';
import SelectInputComponent from '@/components/common/SelectInputComponent.vue';
import FlagPickerComponent from '@/components/common/FlagPickerComponent.vue';
import { GetTravelTypeLabel, GetUserStatusLabel } from '@/compositions/helper';
import * as zod from 'zod';

const travel = defineModel<AdminTravel>({ required: true });
const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const eventUrl = computed(() => {
  const slugSource = travel.value.slug?.trim() || travel.value.name;
  const slug = slugSource
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
    .toLowerCase()
    .replace(/[\s-]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return slug ? `${window.location.origin}/${slug}` : '';
});

const props = defineProps<{
  anchor?: string
}>();

const tagValidator = (tag: string, choices?: string[]) => ((choices?.map(choice => choice.toLowerCase())?.indexOf(tag.toLowerCase())) ?? -1) === -1
// const clientManagerssToAddList = ref<ClientManagerDb[]>([]);

// const searchclientManagersChange = (query: string) => {
//   if (travel.value) {
//     adminApi
//       .getUsers({search: query })
//       .then((response) => {
//         clientManagerssToAddList.value = response.data.items.map((item) => ({ id: 0, user: item }));
//       })
//       .catch((error: Error) => {
//         notificationsStore.notifyError(
//           'Erreur lors de la recherche des participants.',
//           error.message,
//         );
//       });
//   } else {
//     notificationsStore.notifyError(
//       'Evénement non chargé. Impossible de rechercher des participants.',
//     );
//   }
// };

onMounted(() => {
  validationSchema.value = {
    shape: {
      name: zod
          .string({message : "Nom de l'événement non valide"})
          .trim()
          .min(1, { message: 'Le nom de l\'événement est obligatoire' })
          .min(3, { message: 'Le nom doit contenir au moins 3 caractères' }),
      slug: zod
        .string()
        .trim()
        .max(200, { message: 'Le slug ne peut pas dépasser 200 caractères' })
        .nullish(),
      type: zod
        .nativeEnum(TravelDbTypeEnum, { message: 'Type d\'événement non valide' }),
      startDate: zod
        .date({ message: 'Date de début non valide' }),
      endDate: zod
        .date({ message: 'Date de fin non valide' }),
      registrationStartDate: zod
        .date({ message: 'Date de début des inscriptions non valide' }),
      registrationEndDate: zod
        .date({ message: 'Date de fin des inscriptions non valide' }),
      nights: zod
        .number({ message: 'Nombre de nuits non valide' })
        //.min(1, { message: 'Le nombre de nuits doit être au moins 1' })
        .nonnegative({ message: 'Le nombre de nuits doit être positif' }),
      company: zod.string()
        .trim()
        .max(100, { message: 'Le nom de l\'entreprise ne peut pas dépasser 100 caractères' })
        .optional(),
      organisationMemberCount: zod
        .number({ message: 'Nombre d\'organisateurs non valide' })
        .nonnegative({ message: 'Le nombre d\'organisateurs doit être positif' }),
      emailContact: zod
        .string({ message: 'Email de contact non valide' })
        .trim()
        .email('L\'email de contact doit être valide'),
      birthDateRequired: zod
        .boolean({ message: 'La date de naissance est-elle requise pour cet événement?' }),
      addressRequired: zod
        .boolean({ message: 'L\'adresse est-elle requise pour cet événement?' }),
      passeportRequired: zod
        .boolean({ message: 'Le passeport est-il requis pour cet événement?' }),
      passeportSixMonthsRequired: zod
        .boolean({ message: 'Le passeport doit-il être valide 6 mois après la date de retour ?' }).optional(),
      estaRequired: zod
        .boolean({ message: "L'ESTA est-il requis pour cet événement ?" }),
      userStatusRequired: zod
        .boolean({ message: 'Le statut de l\'utilisateur est-il requis pour cet événement?' }),
      usersStatusAvailable: zod
        .array(zod.nativeEnum(UserStatusEnum))
        .optional()
        .refine((statuses) => !travel.value.userStatusRequired || (statuses && statuses.length > 0), { message: 'Veuillez sélectionner au moins un statut utilisateur' }),
      emergencyContactRequested: zod
        .boolean({ message: 'Le contact d\'urgence est-il demandé pour cet événement?' }),
      invoiceEnabled: zod
        .boolean({ message: 'La page de facturation est-elle activée pour cet événement?' }),
      companionsEnabled: zod
        .boolean({ message: 'Les accompagnants sont-ils autorisés pour cet événement?' }),
      nationalityRequired: zod
        .boolean({ message: 'La nationalité est-elle requise pour cet événement?' }),
      invitationTemplateId: zod
        .number({ message: 'Template email d\'invitation non valide' }),
      confirmationTemplateId: zod
        .number({ message: 'Template email Confirmation Inscription non valide' }),
      optoutTemplateId: zod
        .number({ message: 'Template email Absents non valide' }).nullish(),
      webInscriptionTemplateId: zod
        .number({ message: 'Template email Réception Fiche Inscription non valide' }).nullish(),
      reminderTemplateId: zod
        .number({ message: 'Template email Rappel 1 non valide' }).nullish(),
      canRefuse: zod
        .boolean({ message: 'Le droit de refus est-il requis pour cet événement?' }),
      needRefusalReason: zod
        .boolean({ message: 'La raison de refus est-elle requise pour cet événement?' })
        .optional(),
      refusalReasons: zod
        .array(zod.string())
        .optional().refine((reasons) => !travel.value.needRefusalReason || (reasons && reasons.length > 0), { message: 'Veuillez fournir au moins une raison de refus' }),
      refusalReasons2: zod
        .array(zod.string())
        .optional(),
      firmaTemplateId: zod
        .string()
        .trim()
        .optional()
        .or(zod.literal('')),
      isoCode: zod
        .string()
        .length(2, { message: 'Le code ISO doit contenir 2 caractères' })
        .toUpperCase()
        .optional()
        .nullable(),
      refusalLabel: zod
        .string()
        .trim()
        .max(200, { message: 'Le label de refus ne peut pas dépasser 200 caractères' })
        .optional()
        .nullable(),
      refusalLongLabel: zod
        .string()
        .trim()
        .max(255, { message: 'Le label de la page de refus ne peut pas dépasser 255 caractères' })
        .optional()
        .nullable(),
      buttonPackageSelectionLabel: zod
        .string()
        .trim()
        .max(200, { message: 'Le label du bouton de sélection du package ne peut pas dépasser 200 caractères' })
        .optional()
        .nullable(),
      companionLabel: zod
        .string()
        .trim()
        .max(200, { message: 'Le label de l\'accompagnant ne peut pas dépasser 200 caractères' })
        .optional()
        .nullable(),
      clientManagers: zod
        .array(zod.object({
          id: zod.number(),
          user: zod.object({
            id: zod.number(),
            firstName: zod.string(),
            lastName: zod.string()
          }),
        })).nullish()
    },
    anchors: {
      "name": props.anchor,
      "type": props.anchor,
      "startDate": props.anchor,
      "endDate": props.anchor,
      "registrationStartDate": props.anchor,
      "registrationEndDate": props.anchor,
      "nights": props.anchor,
      "company": props.anchor,
      "organisationMemberCount": props.anchor,
      "birthDateRequired": props.anchor,
      "addressRequired": props.anchor,
      "passeportRequired": props.anchor,
      "passeportSixMonthsRequired": props.anchor,
      "estaRequired": props.anchor,
      "userStatusRequired": props.anchor,
      "usersStatusAvailable": props.anchor,
      "nationalityRequired": props.anchor,
      "emergencyContactRequested": props.anchor,
      "invoiceEnabled": props.anchor,
      "companionsEnabled": props.anchor,
      "emailContact": props.anchor,
      "invitationTemplateId": props.anchor,
      "confirmationTemplateId": props.anchor,
      "optoutTemplateId": props.anchor,
      "webInscriptionTemplateId": props.anchor,
      "reminderTemplateId": props.anchor,
      "canRefuse": props.anchor,
      "needRefusalReason": props.anchor,
      "refusalReasons": props.anchor,
      "refusalReasons2": props.anchor,
      "firmaTemplateId": props.anchor,
      "isoCode": props.anchor,
      "refusalLabel": props.anchor,
      "refusalLongLabel": props.anchor,
      "buttonPackageSelectionLabel": props.anchor,
      // "clientManagers": props.anchor,
      "companionLabel": props.anchor,
    }
  }
});
</script>
